export enum ModuleCategory {
    Pinned = 'pinned',
    Running = 'running',
    Upcoming = 'upcoming',
    Ended = 'ended',
    Published = 'published',
    Archived = 'archived',
    Unpublished = 'unpublished',
}
